import React from "react";
import classNames from "classnames";

import { makeStyles } from "@material-ui/core";

import HStack from "modules/core/components/HStack";

interface IStepsIndicatorProps {
  stepsCount: number;
  currentStep: number;
}

const useStyles = makeStyles(theme => ({
  step: {
    width: 15,
    height: 10,
    borderRadius: 10,
    backgroundColor: theme.palette.grey[300],
    transition: theme.transitions.create("all", {
      duration: theme.transitions.duration.short,
      easing: theme.transitions.easing.sharp
    })
  },

  activeStep: {
    backgroundColor: theme.palette.primary.main,
    width: 50
  }
}));

const StepsIndicator: React.FC<IStepsIndicatorProps> = props => {
  const { currentStep, stepsCount } = props;

  const classes = useStyles();

  return (
    <HStack gap={4}>
      {Array.from({ length: stepsCount }, (_, index) => (
        <div
          key={index}
          className={classNames(classes.step, {
            [classes.activeStep]: index === currentStep
          })}
        />
      ))}
    </HStack>
  );
};

export default React.memo(StepsIndicator);
